/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: uVCijascbjQQ

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { SideEffect } from "@plasmicpkgs/plasmic-basic-components";
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicFooterBottom.module.css"; // plasmic-import: uVCijascbjQQ/css

createPlasmicElementProxy;

export type PlasmicFooterBottom__VariantMembers = {};
export type PlasmicFooterBottom__VariantsArgs = {};
type VariantPropType = keyof PlasmicFooterBottom__VariantsArgs;
export const PlasmicFooterBottom__VariantProps = new Array<VariantPropType>();

export type PlasmicFooterBottom__ArgsType = {};
type ArgPropType = keyof PlasmicFooterBottom__ArgsType;
export const PlasmicFooterBottom__ArgProps = new Array<ArgPropType>();

export type PlasmicFooterBottom__OverridesType = {
  footerBottom?: Flex__<"div">;
  wrapper?: Flex__<"div">;
  copy?: Flex__<"div">;
  logo?: Flex__<"div">;
  img?: Flex__<typeof PlasmicImg__>;
  desc?: Flex__<"div">;
  sideEffect?: Flex__<typeof SideEffect>;
  trademark?: Flex__<"p">;
  trademark2?: Flex__<"p">;
  security?: Flex__<"div">;
  left?: Flex__<"div">;
  sslLink?: Flex__<"a"> & Partial<LinkProps>;
  ssl?: Flex__<typeof PlasmicImg__>;
  smLink?: Flex__<"a"> & Partial<LinkProps>;
  sm?: Flex__<typeof PlasmicImg__>;
  right?: Flex__<"div">;
  trusteLink?: Flex__<"a"> & Partial<LinkProps>;
  truste?: Flex__<typeof PlasmicImg__>;
  socLink?: Flex__<"a"> & Partial<LinkProps>;
  soc?: Flex__<typeof PlasmicImg__>;
};

export interface DefaultFooterBottomProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicFooterBottom__RenderFunc(props: {
  variants: PlasmicFooterBottom__VariantsArgs;
  args: PlasmicFooterBottom__ArgsType;
  overrides: PlasmicFooterBottom__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "currentYear",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"footerBottom"}
      data-plasmic-override={overrides.footerBottom}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.footerBottom
      )}
    >
      <div
        data-plasmic-name={"wrapper"}
        data-plasmic-override={overrides.wrapper}
        className={classNames(projectcss.all, sty.wrapper)}
      >
        <div
          data-plasmic-name={"copy"}
          data-plasmic-override={overrides.copy}
          className={classNames(projectcss.all, sty.copy)}
        >
          <div
            data-plasmic-name={"logo"}
            data-plasmic-override={overrides.logo}
            className={classNames(projectcss.all, sty.logo)}
          >
            <PlasmicImg__
              data-plasmic-name={"img"}
              data-plasmic-override={overrides.img}
              alt={""}
              className={classNames(sty.img)}
              displayHeight={"19.887px"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"113.777px"}
              loader={"plasmic"}
              loading={"lazy"}
              src={{
                src: "https://site-assets.plasmic.app/e0d717efc79e1714572b0ff755fc9dba.svg",
                fullWidth: 113.777,
                fullHeight: 19.887,
                aspectRatio: 5.7
              }}
            />
          </div>
          <div
            data-plasmic-name={"desc"}
            data-plasmic-override={overrides.desc}
            className={classNames(projectcss.all, sty.desc)}
          >
            <SideEffect
              data-plasmic-name={"sideEffect"}
              data-plasmic-override={overrides.sideEffect}
              className={classNames("__wab_instance", sty.sideEffect)}
              onMount={async () => {
                const $steps = {};

                $steps["updateCurrentYear"] = true
                  ? (() => {
                      const actionArgs = {
                        variable: {
                          objRoot: $state,
                          variablePath: ["currentYear"]
                        },
                        operation: 0,
                        value: new Date().getFullYear().toString()
                      };
                      return (({
                        variable,
                        value,
                        startIndex,
                        deleteCount
                      }) => {
                        if (!variable) {
                          return;
                        }
                        const { objRoot, variablePath } = variable;

                        $stateSet(objRoot, variablePath, value);
                        return value;
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["updateCurrentYear"] != null &&
                  typeof $steps["updateCurrentYear"] === "object" &&
                  typeof $steps["updateCurrentYear"].then === "function"
                ) {
                  $steps["updateCurrentYear"] =
                    await $steps["updateCurrentYear"];
                }
              }}
            />

            <p
              data-plasmic-name={"trademark"}
              data-plasmic-override={overrides.trademark}
              className={classNames(
                projectcss.all,
                projectcss.p,
                projectcss.__wab_text,
                sty.trademark
              )}
            >
              <React.Fragment>{`MyEvaluations.com, MyGME, MyPortfolio, MyInsights, and MyQuickPass are registered trademarks of MyEvaluations.com Inc. © 1998-${$state.currentYear}.`}</React.Fragment>
            </p>
            <p
              data-plasmic-name={"trademark2"}
              data-plasmic-override={overrides.trademark2}
              className={classNames(
                projectcss.all,
                projectcss.p,
                projectcss.__wab_text,
                sty.trademark2
              )}
            >
              {"U.S. Patent #7,899,702. All rights reserved."}
            </p>
          </div>
        </div>
        <div
          data-plasmic-name={"security"}
          data-plasmic-override={overrides.security}
          className={classNames(projectcss.all, sty.security)}
        >
          <div
            data-plasmic-name={"left"}
            data-plasmic-override={overrides.left}
            className={classNames(projectcss.all, sty.left)}
          >
            <PlasmicLink__
              data-plasmic-name={"sslLink"}
              data-plasmic-override={overrides.sslLink}
              aria-label={
                hasVariant(globalVariants, "mobile", "tabletLandscape")
                  ? "Open SSL report"
                  : "Open SSL report"
              }
              className={classNames(projectcss.all, projectcss.a, sty.sslLink)}
              component={Link}
              href={
                "https://secure.ssl.com/site_seals/afc62e84-546bd429/site_report"
              }
              platform={"nextjs"}
              target={"_blank"}
              title={
                hasVariant(globalVariants, "mobile", "tabletLandscape")
                  ? "Open SSL report"
                  : "Open SSL report"
              }
            >
              <PlasmicImg__
                data-plasmic-name={"ssl"}
                data-plasmic-override={overrides.ssl}
                alt={""}
                className={classNames(sty.ssl)}
                displayHeight={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? "40px"
                    : hasVariant(globalVariants, "mobile", "mobile")
                      ? "auto"
                      : "40px"
                }
                displayMaxHeight={"none"}
                displayMaxWidth={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? "auto"
                    : "100%"
                }
                displayMinHeight={"0"}
                displayMinWidth={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? "87.91px"
                    : "0"
                }
                displayWidth={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? "87.91px"
                    : hasVariant(globalVariants, "mobile", "mobile")
                      ? "auto"
                      : "auto"
                }
                loader={"plasmic"}
                loading={"lazy"}
                src={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? {
                        src: "https://site-assets.plasmic.app/2d5de59cbdbc131416fa5f8a225e5195.svg",
                        fullWidth: 88,
                        fullHeight: 40,
                        aspectRatio: 2.2
                      }
                    : {
                        src: "https://img.plasmic.app/img-optimizer/v1/img/4ab1ac2f1dd01109d3a901aaf2688737.png",
                        fullWidth: 768,
                        fullHeight: 350
                      }
                }
              />
            </PlasmicLink__>
            <PlasmicLink__
              data-plasmic-name={"smLink"}
              data-plasmic-override={overrides.smLink}
              aria-label={"Open Security Metrics certificate"}
              className={classNames(projectcss.all, projectcss.a, sty.smLink)}
              component={Link}
              href={
                "https://www.securitymetrics.com/site_certificate?id=1620588&tk=cc623455be6f550b5bad316af1ed043c"
              }
              platform={"nextjs"}
              target={"_blank"}
              title={"Open Security Metrics certificate"}
            >
              <PlasmicImg__
                data-plasmic-name={"sm"}
                data-plasmic-override={overrides.sm}
                alt={""}
                className={classNames(sty.sm)}
                displayHeight={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? "60px"
                    : hasVariant(globalVariants, "mobile", "mobile")
                      ? "auto"
                      : "40px"
                }
                displayMaxHeight={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? "60px"
                    : hasVariant(globalVariants, "mobile", "mobile")
                      ? "40px"
                      : "none"
                }
                displayMaxWidth={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? "104.28px"
                    : hasVariant(globalVariants, "mobile", "mobile")
                      ? "88px"
                      : "100%"
                }
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? "104.28px"
                    : hasVariant(globalVariants, "mobile", "mobile")
                      ? "auto"
                      : "97.32px"
                }
                loader={"plasmic"}
                loading={"lazy"}
                src={{
                  src: "https://site-assets.plasmic.app/a34f7265d905c2536c366e7049ea697a.svg",
                  fullWidth: 265,
                  fullHeight: 150,
                  aspectRatio: 1.767857
                }}
              />
            </PlasmicLink__>
          </div>
          <div
            data-plasmic-name={"right"}
            data-plasmic-override={overrides.right}
            className={classNames(projectcss.all, sty.right)}
          >
            <PlasmicLink__
              data-plasmic-name={"trusteLink"}
              data-plasmic-override={overrides.trusteLink}
              aria-label={"Open TRUSTe certificate"}
              className={classNames(
                projectcss.all,
                projectcss.a,
                sty.trusteLink
              )}
              component={Link}
              href={
                "https://privacy.trustarc.com/privacy-seal/validation?rid=f8bd7343-167e-42af-b87d-f103b7db3712"
              }
              platform={"nextjs"}
              target={"_blank"}
              title={"Open TRUSTe certificate"}
            >
              <PlasmicImg__
                data-plasmic-name={"truste"}
                data-plasmic-override={overrides.truste}
                alt={""}
                className={classNames(sty.truste)}
                displayHeight={
                  hasVariant(globalVariants, "mobile", "mobile")
                    ? "auto"
                    : "40px"
                }
                displayMaxHeight={
                  hasVariant(globalVariants, "mobile", "mobile")
                    ? "40px"
                    : "none"
                }
                displayMaxWidth={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? "125.96px"
                    : hasVariant(globalVariants, "mobile", "mobile")
                      ? "126px"
                      : "100%"
                }
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? "125.96px"
                    : hasVariant(globalVariants, "mobile", "mobile")
                      ? "auto"
                      : "125.96px"
                }
                loader={"plasmic"}
                loading={"lazy"}
                src={
                  "https://hostedseal.trustarc.com/privacy-seal/seal?rid=f8bd7343-167e-42af-b87d-f103b7db3712"
                }
              />
            </PlasmicLink__>
            <PlasmicLink__
              data-plasmic-name={"socLink"}
              data-plasmic-override={overrides.socLink}
              aria-label={"Open SOC 2 details"}
              className={classNames(projectcss.all, projectcss.a, sty.socLink)}
              component={Link}
              href={
                "https://www.aicpa-cima.com/topic/audit-assurance/audit-and-assurance-greater-than-soc-2"
              }
              platform={"nextjs"}
              target={"_blank"}
              title={"Open SOC 2 details"}
            >
              <PlasmicImg__
                data-plasmic-name={"soc"}
                data-plasmic-override={overrides.soc}
                alt={"SOC 2 logo"}
                className={classNames(sty.soc)}
                displayHeight={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? "100%"
                    : hasVariant(globalVariants, "mobile", "mobile")
                      ? "auto"
                      : "100%"
                }
                displayMaxHeight={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? "none"
                    : hasVariant(globalVariants, "mobile", "mobile")
                      ? "40px"
                      : "none"
                }
                displayMaxWidth={
                  hasVariant(globalVariants, "mobile", "mobile")
                    ? "95.33px"
                    : "100%"
                }
                displayMinHeight={"0"}
                displayMinWidth={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? "144.29px"
                    : "0"
                }
                displayWidth={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? "144.29px"
                    : hasVariant(globalVariants, "mobile", "mobile")
                      ? "auto"
                      : "100%"
                }
                loader={"plasmic"}
                loading={"lazy"}
                src={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? {
                        src: "https://site-assets.plasmic.app/0ddc908077ed7b1ea721666e7fe586d8.svg",
                        fullWidth: 145,
                        fullHeight: 60,
                        aspectRatio: 2.416667
                      }
                    : {
                        src: "https://site-assets.plasmic.app/eb1c7bf06ca966644a4545bce3f37ddc.svg",
                        fullWidth: 96,
                        fullHeight: 40,
                        aspectRatio: 2.4
                      }
                }
              />
            </PlasmicLink__>
          </div>
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  footerBottom: [
    "footerBottom",
    "wrapper",
    "copy",
    "logo",
    "img",
    "desc",
    "sideEffect",
    "trademark",
    "trademark2",
    "security",
    "left",
    "sslLink",
    "ssl",
    "smLink",
    "sm",
    "right",
    "trusteLink",
    "truste",
    "socLink",
    "soc"
  ],
  wrapper: [
    "wrapper",
    "copy",
    "logo",
    "img",
    "desc",
    "sideEffect",
    "trademark",
    "trademark2",
    "security",
    "left",
    "sslLink",
    "ssl",
    "smLink",
    "sm",
    "right",
    "trusteLink",
    "truste",
    "socLink",
    "soc"
  ],
  copy: [
    "copy",
    "logo",
    "img",
    "desc",
    "sideEffect",
    "trademark",
    "trademark2"
  ],
  logo: ["logo", "img"],
  img: ["img"],
  desc: ["desc", "sideEffect", "trademark", "trademark2"],
  sideEffect: ["sideEffect"],
  trademark: ["trademark"],
  trademark2: ["trademark2"],
  security: [
    "security",
    "left",
    "sslLink",
    "ssl",
    "smLink",
    "sm",
    "right",
    "trusteLink",
    "truste",
    "socLink",
    "soc"
  ],
  left: ["left", "sslLink", "ssl", "smLink", "sm"],
  sslLink: ["sslLink", "ssl"],
  ssl: ["ssl"],
  smLink: ["smLink", "sm"],
  sm: ["sm"],
  right: ["right", "trusteLink", "truste", "socLink", "soc"],
  trusteLink: ["trusteLink", "truste"],
  truste: ["truste"],
  socLink: ["socLink", "soc"],
  soc: ["soc"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  footerBottom: "div";
  wrapper: "div";
  copy: "div";
  logo: "div";
  img: typeof PlasmicImg__;
  desc: "div";
  sideEffect: typeof SideEffect;
  trademark: "p";
  trademark2: "p";
  security: "div";
  left: "div";
  sslLink: "a";
  ssl: typeof PlasmicImg__;
  smLink: "a";
  sm: typeof PlasmicImg__;
  right: "div";
  trusteLink: "a";
  truste: typeof PlasmicImg__;
  socLink: "a";
  soc: typeof PlasmicImg__;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFooterBottom__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFooterBottom__VariantsArgs;
    args?: PlasmicFooterBottom__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicFooterBottom__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicFooterBottom__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFooterBottom__ArgProps,
          internalVariantPropNames: PlasmicFooterBottom__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFooterBottom__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "footerBottom") {
    func.displayName = "PlasmicFooterBottom";
  } else {
    func.displayName = `PlasmicFooterBottom.${nodeName}`;
  }
  return func;
}

export const PlasmicFooterBottom = Object.assign(
  // Top-level PlasmicFooterBottom renders the root element
  makeNodeComponent("footerBottom"),
  {
    // Helper components rendering sub-elements
    wrapper: makeNodeComponent("wrapper"),
    copy: makeNodeComponent("copy"),
    logo: makeNodeComponent("logo"),
    img: makeNodeComponent("img"),
    desc: makeNodeComponent("desc"),
    sideEffect: makeNodeComponent("sideEffect"),
    trademark: makeNodeComponent("trademark"),
    trademark2: makeNodeComponent("trademark2"),
    security: makeNodeComponent("security"),
    left: makeNodeComponent("left"),
    sslLink: makeNodeComponent("sslLink"),
    ssl: makeNodeComponent("ssl"),
    smLink: makeNodeComponent("smLink"),
    sm: makeNodeComponent("sm"),
    right: makeNodeComponent("right"),
    trusteLink: makeNodeComponent("trusteLink"),
    truste: makeNodeComponent("truste"),
    socLink: makeNodeComponent("socLink"),
    soc: makeNodeComponent("soc"),

    // Metadata about props expected for PlasmicFooterBottom
    internalVariantProps: PlasmicFooterBottom__VariantProps,
    internalArgProps: PlasmicFooterBottom__ArgProps
  }
);

export default PlasmicFooterBottom;
/* prettier-ignore-end */
